<template>
	<nav id="breadcrumbs" class="col-12">
		<div class="singleBreadcrumb" v-for="(crumb, index) in breadcrumbs" :key="index">
			<router-link :to="crumb.link">{{crumb.text}}</router-link>
			<span class="separator">/</span>
		</div>
	</nav>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "Breadcrumbs",
	components: {},
	computed: {
		...mapGetters({
			// map categories to store.reference.categories
			categories: "reference/categoriesMap"
		}),
		breadcrumbs(){
			// This is a mess and I'm sorry :(
			let crumbs = [];
			let catLength = Object.keys(this.categories).length
			let source = this.$route.params.source
			if(source) {
				if(source == "search") {
					return [{text:'Home', link:{name:'home'}}, {text:'Shop', link:{path:'/shop'}}, {text:'Search', link:{name:'search', query: {s:this.$route.query.s}}}]
				} else if (source == "specials") {
					return [{text:'Home', link:{name:'home'}}, {text:'Shop', link:{path:'/shop'}}, {text:'Specials', link:{name:'specials'}}]
				} else if (source == "window") {
					return [{text:'Home', link:{name:'home'}}, {text:'Window Shop', link:{path:'/window_shop'}}]
				}
			}


			crumbs.push({text: 'Home', link: {name: 'home'}})  // First breadcrumb is always home

			//all top level pages are staticly named
			if(this.$route.matched[0]){
				let matched = this.$route.matched[0]
				let text;
				if('breadcrumb' in matched.meta){
					text = matched.meta.breadcrumb;
				}else{
					throw new Error("no breadcrumb ", matched)
				}
				crumbs.push({text: text, link: {path: matched.path}})
			}

			if(crumbs[1].text == "Shop"){
				//if its the shop make category page
				let cat = this.$route.params.category || this.$route.query.category
				if(cat && catLength){
					let text = this.categories[cat].category
					let link = {name: 'category', params: {category:cat}}
					crumbs.push({link, text});
				}

				let subcat = this.$route.params.subcategory || this.$route.query.subcategory
				if(subcat && catLength){
					let text = this.categories[subcat].category
					let link = {name: 'subcategory', params: {category: cat, subcategory: subcat}}
					crumbs.push({link, text});
				}

				if(this.$route.name == "specials") {
					let text = "Specials";
					let link = {name: 'specials'}
					crumbs.push({link, text})
				}
			}else{
				if(this.$route.matched[1]){
					let matched = this.$route.matched[1];
					if('breadcrumb' in matched.meta){
						let text = matched.meta.breadcrumb;
						let link = {path: matched.path}
						crumbs.push({text, link})

						//next level
						if(text == "Member Biz"){
							let location = this.$route.params.location || this.$route.query.location
							if(location){

								let text = this.categories[location].category;
								let link = {name:'memberBizLocation', params:{location}}

								crumbs.push({text, link})
							}
						}else if(text == "Discount Partners"){
							// debugger;
							let location = this.$route.params.location || this.$route.query.location
							if(location){

								let text = this.categories[location].category;
								let link = {name:'discountPartnerLocation', params:{location}}

								crumbs.push({text, link})
							}
						}
					}
				}

			}
			return crumbs;
		}

	}
};
</script>

<style lang="scss" scoped>
#breadcrumbs {
	color: $CTred;
	a {
		color: inherit;
		text-decoration: none;
		font-size: 0.8em;
		&:hover {
		color: black;
		}
	}
	.separator {
		padding-left: 2px;
		padding-right: 2px;
		font-weight: 500;
		font-size: 1em;
	}
	.singleBreadcrumb{
		display: inline-block;
		&:last-child {
			.separator {
			display: none; //hide last separator
			}
		}
	}
}
</style>
